const posts_management_en = {
  edit_posts_info:'Edit position information',
  empty_posts_name:'Please enter the position name',
  empty_posts_code:'Please enter position code'
}

export default posts_management_en



// WEBPACK FOOTER //
// ./src/common/lang/posts_management/posts_management_en.js